export default __webpack_public_path__ + "static/media/HOME-banner@2x.c9ead79c.png";